import {isNotNil} from 'ramda';

import {getWorkspaceFromUri, Workspace} from './getWorkspaceFromUri';

/**
 * Workspaces used for B2C CarAudit (Digital certificate) reports.
 * Cebia workspace serves CZ/SK, report workspace serves other countries with a neutral URL.
 * Both share the extended display – brake lining wear alert, paint thickness severity scale
 * and similar cars section.
 */
const B2C_CARAUDIT_WORKSPACES: Workspace[] = ['cebia', 'report'];

export function isB2cCarAuditWorkspace() {
  const {workspace} = getWorkspaceFromUri();

  return isNotNil(workspace) && B2C_CARAUDIT_WORKSPACES.includes(workspace);
}
